export default "__VITE_ASSET__e4029f96__"